module.exports = __webpack_public_path__ + "static/capsule-crm-668839a2d64a3a8b11485b98559b1ea0.svg";